import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 
import { AppThunk } from 'app/store/store';
import { getAccount, steemCustomApi } from 'services/dsteem-service';
import { getContent } from 'services/posts-service'; 
import { get_views } from 'services/db-service';
import { getCommunity } from 'services/community-service';

// import { post as postService } from 'services/api-service';

type PostState = {
  post: any,
  // user: any,
  isLoading: boolean
  error: string | null
}

const postInitialState: PostState = {
  post: null,
  // user:null,
  isLoading: true,
  error: null
}

function startLoading(state: PostState) {
  state.isLoading = true;
  state.post = null;
}

function loadingFailed(state: PostState, action: PayloadAction<string>) {
  state.isLoading = false
  state.error = action.payload
}

const post = createSlice({
  name: 'post',
  initialState: postInitialState,
  reducers: {
    getPostStart: startLoading,
    getPostSuccess(state, { payload }: PayloadAction<any>) {
      state.isLoading = false
      state.error = null
      state.post = payload
    },
    getPostFailure: loadingFailed
  }
});

export const {
  getPostStart,
  getPostSuccess,
  getPostFailure
} = post.actions;

export default post.reducer;

export const fetchPost = (author: string, permlink: string): AppThunk => async dispatch => {
  try {
    dispatch(getPostStart())
    const post = await getContent(author, permlink);
    const user = await getAccount(author); 
    const reward_fund = await steemCustomApi("condenser_api.get_reward_fund", ["post"]);
    const median_price = await steemCustomApi("condenser_api.get_current_median_history_price", []);
    const followers_count = await steemCustomApi("condenser_api.get_follow_count", [author]); 
    const shared_by = await steemCustomApi("follow_api.get_reblogged_by", {author, permlink}); 
    const community = await getCommunity(post.category || "", post.author);

    let views = 0; 
    try {
      const response = await get_views(author); 
      
      const fullUrl = `/@${author}/${permlink}`; 
      
      const viewEntry = response.find(item => item.url === fullUrl); 
      
      if (viewEntry) {
        views = viewEntry.count;
      }
    } catch (viewErr) {
      console.warn('Wasnt able to get views count:', viewErr);
    }

    let data = {
      ...post,
      user, 
      reward_fund,
      median_price,
      followers_count,
      shared_by,
      community,
      views
    }
    dispatch(getPostSuccess(data));
  } catch (err) {
    dispatch(getPostFailure(err.toString()));
  }
}